import { render, staticRenderFns } from "./slideProd.vue?vue&type=template&id=862133d6&scoped=true&"
import script from "./slideProd.vue?vue&type=script&lang=js&"
export * from "./slideProd.vue?vue&type=script&lang=js&"
import style0 from "./slideProd.vue?vue&type=style&index=0&id=862133d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862133d6",
  null
  
)

export default component.exports